import { RiArchiveLine, RiArrowDownLine, RiArrowRightLine, RiPhoneLine } from 'react-icons/ri';

import { ProductCard } from '@/entities/product/product-card';

import type { Product } from '@/shared/api/generated/api.generated';

import { ReplacementRequest } from './replacement-request';

export const DiscontinuedProductPanel = ({ productName, count }: { productName: string; count: number }) => (
  <>
    <span className="discontinued-badge">
      <RiArchiveLine aria-hidden /> Снят с производства
    </span>
    <h2>Эта модель больше не производится.</h2>
    <p className="discontinued-panel__intro">
      Но для вашей задачи есть другие решения. Поможем подобрать станок с подходящими характеристиками.
    </p>
    {count > 0 && (
      <a className="precision-button" href="#alternatives">
        Смотреть аналоги
        <span>
          {count} <RiArrowDownLine aria-hidden />
        </span>
      </a>
    )}
    <ReplacementRequest
      productName={productName}
      className={`precision-button${count > 0 ? ' precision-button--outline' : ''}`}
    />
    <div className="discontinued-panel__help">
      <p>Обсудим замену со специалистом</p>
      <a href="tel:+73433630507">
        <RiPhoneLine aria-hidden /> +7 (343) 363-05-07
      </a>
      <span>Пн–Пт: 10:00–19:00</span>
    </div>
    <p className="discontinued-panel__footnote">Описание и характеристики модели сохранены ниже.</p>
  </>
);

export const ProductAlternatives = ({ products, productName }: { products: Product[]; productName: string }) => (
  <section className="product-alternatives" id="alternatives" aria-labelledby="alternatives-title">
    <div className="product-alternatives__heading">
      <div>
        <p className="eyebrow">АКТУАЛЬНОЕ ОБОРУДОВАНИЕ</p>
        <h2 id="alternatives-title">Чем заменить эту модель</h2>
      </div>
      <p>Модели со схожим назначением. Сравним параметры и комплектацию под ваше производство.</p>
    </div>
    {products.length > 0 ? (
      <div className="product-alternatives__grid">
        {products.map((item, index) => (
          <div className="product-alternative" key={item.id}>
            <div className="product-alternative__label">
              <span>0{index + 1} / ВАРИАНТ ЗАМЕНЫ</span>
              <RiArrowRightLine aria-hidden />
            </div>
            <ProductCard item={item} />
          </div>
        ))}
      </div>
    ) : (
      <p className="product-alternatives__empty">
        Для этой модели подберём замену индивидуально. Расскажите нам о вашей задаче.
      </p>
    )}
    <div className="product-alternatives__personal">
      <div>
        <h3>Нужны другие параметры?</h3>
        <p>Подберём оборудование под ваш материал, объём производства и бюджет.</p>
      </div>
      <ReplacementRequest productName={productName} label="Подобрать другой вариант" />
    </div>
  </section>
);
